import { apiAxios } from '@/api'
import { fetchWrapper } from '@/reducers/fetch'
import type {
  BillingInformation,
  CardSummary,
  OpenInvoiceRetry,
  SetupIntentSession,
  UpdateBillingAddressBody,
} from './payment-method.types'

const BASE = '/finances/api/v1/stripe/payment_method'
const BILLING_INFORMATION_BASE = '/finances/api/v1/stripe/billing_information'

export const createSetupIntent = () =>
  fetchWrapper({
    shouldHandleError: false,
    fetchFunction: () =>
      apiAxios
        .post<SetupIntentSession>(`${BASE}/setup_intent`)
        .then((json) => json.data),
  })

export const finalizeSetupIntent = (setupIntentId: string) =>
  fetchWrapper({
    shouldHandleError: false,
    fetchFunction: () =>
      apiAxios
        .post<CardSummary | null>(`${BASE}/finalize`, { setupIntentId })
        .then((json) => json.data),
  })

export const fetchCardSummary = () =>
  fetchWrapper({
    shouldHandleError: false,
    fetchFunction: () =>
      apiAxios.get<CardSummary | null>(BASE).then((json) => json.data),
  })

export const fetchOpenInvoiceRetry = () =>
  fetchWrapper({
    shouldHandleError: false,
    fetchFunction: () =>
      apiAxios
        .get<OpenInvoiceRetry>(`${BASE}/open_invoices`)
        .then((json) => json.data),
  })

export const fetchBillingInformation = () =>
  fetchWrapper({
    shouldHandleError: false,
    fetchFunction: () =>
      apiAxios
        .get<BillingInformation>(BILLING_INFORMATION_BASE)
        .then((json) => json.data),
  })

export const updateBillingAddress = (body: UpdateBillingAddressBody) =>
  fetchWrapper({
    shouldHandleError: false,
    fetchFunction: async (): Promise<void> => {
      await apiAxios.put(`${BILLING_INFORMATION_BASE}/address`, body)
    },
  })
